import type { HttpCache, RequestResponse } from '@epimodev/callbag-doki/sources/httpRequest';

// update type when adding an entity data type
const cache: {
  [key: string]: RequestResponse<BlockData> | undefined;
} = {};

const httpCache: HttpCache = {
  pushResponse: ({ url }, response) => {
    cache[url] = response;
  },
  getResponse: ({ url }) => cache[url]
};

export { httpCache };
